<common-modal
  *ngIf="isOpen"
  [isOpen]="isOpen"
  (isOpenChange)="isOpenChange.emit($event)"
  [closeOnEscape]="true"
  [showCloseIcon]="true"
  [scrollableContent]="false"
  position="center"
>
  <ng-container header>
    <h2>
      {{ 'rebalancing.subSources' | translate }}
    </h2>
  </ng-container>
  <ng-container body>
    <div>
      <canvas #sankeyChart></canvas>
    </div>
  </ng-container>
</common-modal>
